module.exports = __webpack_public_path__ + "img/20200514_151058.7f56da61.jpg";